var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AUDIO_EFFECT_NAME, getPreCfgByName } from '../audio-helper';
import BaseAudioEffector from './base-audio-effector';
import { biquadFilterType } from './equalizer-effector';
/**
 * 混响效果
 * 模拟声音在自然传播的效果，添加空间感，相当于可以在模拟不同场景，音乐厅、客厅等
 */
var ReverbEffector = /** @class */ (function (_super) {
    __extends(ReverbEffector, _super);
    function ReverbEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 通道数
        _this.channelNum = 2;
        // 干湿音音量系数
        _this.dryWetConstant = 0.5;
        // 低通频率
        _this.lowPassFrequency = 7e3;
        // 高通频率
        _this.highPassFrequency = 0;
        _this.effectorName = 'Reverb';
        _this.lowPassBfNode = audioCtx.createBiquadFilter();
        _this.lowPassBfNode.type = biquadFilterType.LOWPASS;
        _this.highPassBfNode = audioCtx.createBiquadFilter();
        _this.highPassBfNode.type = biquadFilterType.HIGHTPASS;
        _this.reverbNode = audioCtx.createConvolver();
        _this.dryGainNode = audioCtx.createGain();
        _this.wetGainNode = audioCtx.createGain();
        _this.inputNode = audioCtx.createGain();
        _this.outputNode = audioCtx.createGain();
        return _this;
    }
    ReverbEffector.prototype.connectBy = function (node) {
        if (!node || !this.inputNode) {
            return;
        }
        // 连接头尾
        node.connect(this.inputNode);
        this.setPreConfigName(AUDIO_EFFECT_NAME.DEFAULT);
        return this.outputNode;
    };
    ReverbEffector.prototype.disconnect = function () {
        var _a;
        this.disconnectInnerNode();
        if (this.outputNode) {
            this.outputNode.disconnect();
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " disconnect()"));
    };
    ReverbEffector.prototype.destroy = function () {
        var _a;
        this.disconnect();
        this.inputNode = null;
        this.lowPassBfNode = null;
        this.highPassBfNode = null;
        this.reverbNode = null;
        this.dryGainNode = null;
        this.wetGainNode = null;
        this.outputNode = null;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " destroy()"));
        this.logger = null;
    };
    /**
     * 设置混响预配置
     */
    ReverbEffector.prototype.setPreConfigName = function (effectName) {
        var _a, _b, _c;
        if (effectName === this.currPreCfgName || !this.inputNode) {
            return;
        }
        this.currPreCfgName = effectName;
        this.reconnect();
        if (this.currPreCfgName === AUDIO_EFFECT_NAME.DEFAULT) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log('ReverbEffector setPreConfigName() currPreCfgName is DEFAULT');
            return;
        }
        var cfg = getPreCfgByName(effectName, rvbPreCfgList);
        if (!cfg) {
            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.log("ReverbEffector setPreConfigName() effectName= ".concat(effectName, " cfg is null!"));
            return;
        }
        // 混响buffer
        this.reverbNode.buffer = this.rebuildImpulse(cfg);
        // 低通频率更新
        this.lowPassBfNode.frequency.setValueAtTime(this.lowPassFrequency, this.audioCtx.currentTime);
        // 高通频率更新
        this.highPassBfNode.frequency.setValueAtTime(this.highPassFrequency, this.audioCtx.currentTime);
        // 干湿音音量计算
        var dryWetValue = this.getDryWebValue(cfg.mix);
        this.dryGainNode.gain.value = dryWetValue.dry;
        this.wetGainNode.gain.value = dryWetValue.wet;
        (_c = this.logger) === null || _c === void 0 ? void 0 : _c.log("ReverbEffector setPreConfigName() effectName= ".concat(effectName, " dry=").concat(dryWetValue.dry, " wet=").concat(dryWetValue.wet));
    };
    /**
     * 重新建立节点连接，如果使用默认则头尾input链接output即可
     */
    ReverbEffector.prototype.reconnect = function () {
        this.disconnectInnerNode();
        // 如果是default，只需要input和output连接即可
        if (this.currPreCfgName === AUDIO_EFFECT_NAME.DEFAULT) {
            this.inputNode.connect(this.outputNode);
        }
        else {
            // 干音连接通路
            this.inputNode.connect(this.dryGainNode);
            this.dryGainNode.connect(this.outputNode);
            // 湿音连接通路
            this.inputNode.connect(this.lowPassBfNode);
            this.lowPassBfNode.connect(this.highPassBfNode);
            this.highPassBfNode.connect(this.reverbNode);
            this.reverbNode.connect(this.wetGainNode);
            this.wetGainNode.connect(this.outputNode);
        }
        this.outputNode.gain.value = 1;
    };
    /**
     * 断开内部节点连接，只保留input的被连接节点（断开它的连接节点）和output的连接节点（断开它的被连接节点）
     */
    ReverbEffector.prototype.disconnectInnerNode = function () {
        if (!this.inputNode) {
            return;
        }
        this.inputNode.disconnect();
        this.lowPassBfNode.disconnect();
        this.highPassBfNode.disconnect();
        this.reverbNode.disconnect();
        this.dryGainNode.disconnect();
        this.wetGainNode.disconnect();
    };
    /**
     * 构建简易混响效果
     */
    ReverbEffector.prototype.rebuildImpulse = function (cfg) {
        // 计算音效的采样帧数
        var sampleLen = this.audioCtx.sampleRate * cfg.time;
        // 创建混音
        var buffer = this.audioCtx.createBuffer(this.channelNum, sampleLen, this.audioCtx.sampleRate);
        // 获取左右声道数据
        var channelLeft = buffer.getChannelData(0);
        var channelRight = buffer.getChannelData(1);
        var rev;
        for (var i = 0; i < sampleLen; i++) {
            rev = cfg.reverse ? sampleLen - i : i;
            channelLeft[i] = this.getChannelSample(rev, sampleLen, cfg.decay);
            channelRight[i] = this.getChannelSample(rev, sampleLen, cfg.decay);
        }
        return buffer;
    };
    /**
     * 计算当前声道帧数据
     * */
    ReverbEffector.prototype.getChannelSample = function (rev, sampleLen, decay) {
        var pow = Math.pow((1 - (rev / sampleLen)), decay);
        return ((Math.random() * 2) - 1) * pow;
    };
    /**
     * 根据mix值计算干湿音数值
     */
    ReverbEffector.prototype.getDryWebValue = function (mix) {
        var cfgMix = mix;
        // mix在0~1范围内
        if (mix < 0 || mix > 1) {
            cfgMix = 0;
        }
        if (cfgMix <= this.dryWetConstant) {
            return { dry: 1, wet: 1 - (2 * (this.dryWetConstant - cfgMix)) };
        }
        return { dry: 1 - (2 * (cfgMix - this.dryWetConstant)), wet: 1 };
    };
    return ReverbEffector;
}(BaseAudioEffector));
export default ReverbEffector;
/**
 * Reverb音效预制数据
 */
export var rvbPreCfgList = [
    {
        name: AUDIO_EFFECT_NAME.CONCERT_HALL,
        label: '音乐厅',
        mix: 0.5,
        time: 1.8,
        decay: 2,
        reverse: false,
    }, {
        name: AUDIO_EFFECT_NAME.LIVING_ROOM,
        label: '客厅',
        mix: 0.5,
        time: 1.4,
        decay: 5,
        reverse: false,
    }, {
        name: AUDIO_EFFECT_NAME.LIVE,
        label: '现场',
        mix: 0.3,
        time: 3,
        decay: 5,
        reverse: false,
    },
];
